import { $isTextNode, ParagraphNode } from 'lexical';
import { $isCustomParagraphNode, CustomParagraphNode } from 'modules/Lexical/nodes/CustomParagraphNode';
import { NoWrapNode } from 'modules/Lexical/nodes/NoWrapNode/NoWrapNode';
import * as Constants from 'const';
import { ParagraphType } from 'services/ArtboardConverter/constants';
import { Schemas } from 'services/ArtboardConverter/models';
import { toPx } from 'utils/toPx';
import { ArtboardConverterStyles } from '../convertLexicalEditorState';
import { getParagraphAlign, getParagraphAnchor, getParagraphFontSize, getParagraphLineHeight } from './Paragraph';

type Context = {
  projectType: Constants.ProjectType;
  lineheightNoPx?: boolean;
};

export function createParagraphForText(
  node: ParagraphNode | CustomParagraphNode | NoWrapNode,
  context: Context,
  converterStyles: ArtboardConverterStyles,
  segments: Schemas.Segment[],
): Schemas.TextParagraph {
  const { projectType, lineheightNoPx } = context;

  const firstTextNode = node.getChildren().find($isTextNode);
  const fontSizeNumber = getParagraphFontSize(firstTextNode, converterStyles.fontSize, projectType);
  const lineHeight = $isCustomParagraphNode(node) ? node.getLineHeight() : undefined;

  return {
    type: ParagraphType.PLAINT_TEXT,
    align: getParagraphAlign(node.getFormatType(), converterStyles.paragraphAlign),
    anchor: getParagraphAnchor(node),
    color: converterStyles.color,
    fontFamily: converterStyles.fontFamily,
    fontSize: toPx(fontSizeNumber),
    lineHeight: getParagraphLineHeight(lineHeight, fontSizeNumber, converterStyles.lineHeight, lineheightNoPx),
    segments,
  };
}
